import { getQuery, axios, config, bus } from './index'

let token = decodeURIComponent(getQuery('server_token') || '');
//==========================================
let serverApi = {}

serverApi.get = async function(path,params){
  try{
    let result = await axios.get(`/server_api/${path}`,{
      params,
      headers: {
        'Authorization':token,
      }
    })
    console.log(result);
    if(result.status == 200){
      return result.data;
    }else{
      // console.log(result)
      throw new Error(result.error);
    }
  }catch(e){
    // console.log(e.message);
    // console.log(e.data);
    //e.response.data
    //err.response.status
    // window.err = e;
  }
  
}
serverApi.post = async function(path,params){
  try{
    let result = await axios.post(`/server_api/${path}`,params,{
      
      headers: {
        'Authorization':token,
      }
    })
    console.log(result);
    if(result.status == 200){
      return result.data;
    }else{
      console.log(result)
      throw new Error(result.error);
    }
  }catch(e){
    console.log(e.message);
    console.log(e.data);
    //e.response.data
    //err.response.status
    // window.err = e;
  }
  
}



window.serverApi = serverApi;
export default serverApi;
